import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrderProviderExternalErrorsList } from './OrderProviderExternalErrorsList/OrderProviderExternalErrorsList';

export const orderProviderExternalErrorsResource: ResourceProps = {
  name: Resources.OrderProviderExternalErrors,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: OrderProviderExternalErrorsList,
};
